import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a527b25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-form-viewer" }
const _hoisted_2 = {
  class: "icon mt-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#formEditorModal"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "text-danger mt-4"
}
const _hoisted_5 = ["height", "src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["height", "src"]
const _hoisted_8 = { class: "text-danger mt-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_MarkAsButton = _resolveComponent("MarkAsButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_feather_icon, {
        type: "edit",
        class: "cursor-pointer position-absolute end-0",
        size: "14"
      })
    ]),
    (!_ctx.isLocal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.formIsEmpty && !_ctx.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "The form is empty, it does not contain any fields. "))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("iframe", {
            frameBorder: "0",
            height: `${_ctx.iframeHeight}px`,
            src: _ctx.iframeLink,
            key: _ctx.iframeLink
          }, null, 8, _hoisted_5))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLocal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(), _createElementBlock("iframe", {
            frameBorder: "0",
            height: `${_ctx.iframeHeight}px`,
            src: _ctx.iframeLink,
            key: _ctx.iframeLink
          }, null, 8, _hoisted_7)),
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode("It is a Demo Form, because we cannot display forms in the local environment due to cross-origin issues with the iFrame."),
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.iframeLink), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_MarkAsButton, {
      "onUpdate:status": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('updateStatus', $event))),
      class: "float-end mt-2"
    }),
    _hoisted_10
  ]))
}